<ul class="v-wrapper">
@for (ai of this.validation()?.requiredProps?.analogeIngangen; track ai) {
    @if (this.validationService.isOf(ai)) {
        <li>Missing one of AIs</li>
        <ul>
        @for (idx of ai; track idx) {
            <li>   {{this.validationService.metaAI(idx)?.omschrij}}</li>            
        }
        </ul>
    } @else {
        <li>Missing AI:{{this.validationService.metaAI(ai)?.omschrij}}</li>
    }
}
    
@for (ld of this.validation()?.requiredProps?.losdef; track ld) {
    @if (this.validationService.isOf(ld)) {
        <li>Missing one of properties</li>
        <ul>
        @for (idx of ld; track idx) {
            <li>   {{this.validationService.metaLD(idx)?.omschr}}</li>            
        }
        </ul>
    } @else {
        <li>Missing Prop:{{this.validationService.metaLD(ld)?.omschr}}</li>
    }
}
@for (servo of this.validation()?.requiredProps?.servos; track servo) {
    @if (this.validationService.isOf(servo)) {
        <li>Missing one of servos</li>
        <ul>
        @for (idx of servo; track idx) {
            <li>   {{this.validationService.metaServo(idx)?.omschr}}</li>            
        }
        </ul>
    } @else {
        <li>Missing Servo:{{this.validationService.metaServo(servo)?.omschr}}</li>
    }
}
@for (md of this.validation()?.requiredModules?.modules; track md) {
    @if (this.validationService.isOfM(md)) {
        <li>Missing one of Modules</li>
        <ul>
        @for (idx of md; track idx) {
            <li>   {{this.metaModule(idx)?.name}}</li>            
        }
        </ul>
    } @else {
        <li>Missing Module:{{this.metaModule(md)?.name}}</li>
    }
}
</ul>
